import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { Size } from '../../../../_models/size';
import { CardService } from '../../card.service';
import { ApplicationNotificationService } from '../../../../shared/application-notification.service';

@Component({
  moduleId: module.id,
  selector: 'copy-vertical-component',
  templateUrl: 'copy-vertical.component.html'
})

export class CopyVerticalComponent implements OnInit {
  public verticalCopyForm: FormGroup;

  ngOnInit() {
    // Generate form for vertical copy
    let verticalFormData: any = {};
    for (let size of this.cardService.sizes) {
      if (size !== this.size) {
        verticalFormData[size.name] = [false];
      }
    }
    this.verticalCopyForm = this.formBuilder.group(verticalFormData);
  }

  constructor(public cardService: CardService, private formBuilder: FormBuilder,
              public appNotificationService: ApplicationNotificationService, public dialog: MatDialog,
  @Inject(MAT_DIALOG_DATA) public size: Size) {}


  copyVertical(): void {
    return this.verticalCopyForm.value;
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/copy-configuration/copy-to/copy-vertical.component.ts